// ─── Admin ───────────────────────────────────────────────────────────────────
export const adminSearchOrganisationQuery = "adminSearchOrganisationQuery";
export const adminUsersSearchQuery = "adminUsersSearchQuery";
export const adminAccountDetailsQuery = "adminAccountDetailsQuery";
export const adminUserOrgMembership = "adminUserOrgMembership";
export const adminOrganisationDetailsQuery = "adminOrganisationDetailsQuery";
export const adminOrganisationMembers = "adminOrganisationMembers";
export const adminOrganisationEmails = "adminOrganisationEmails";
export const adminUserEmails = "adminUserEmails";
export const adminAllEmails = "adminAllEmails";
export const adminOrganisationNames = "adminOrganisationNames";
export const adminOrganisationInfoKey = "adminOrganisationInfo";
export const adminUserApiKeys = "adminUserApiKeys";
export const adminUserApiKey = "adminUserApiKey";
export const adminUserMemberships = "adminUserMemberships";
export const adminUserLicences = "adminUserLicences";
export const adminDemosKey = "adminDemos";
export const adminCustomDatasetDefinitions = "adminCustomDatasetsDefinitions";
export const adminCustomDatasetsSearchQuery = "adminCustomDatasetsSearchQuery";
export const adminCustomDatasets = "adminCustomDatasets";
export const adminConnectors = "adminConnectors";
export const adminConnector = "adminConnector";
export const adminOrgSSHKey = "adminOrgSSHKey";
export const adminPipelines = "adminPipelines";
export const adminPipelineLastRun = "adminPipelineLastRun";
export const adminPipelineNextRun = "adminPipelineNextRun";
export const adminPipeline = "adminPipeline";
export const adminClipsKey = "adminClips";
export const adminVaultKey = "adminVault";
export const adminPaymentMethodKey = "adminPaymentMethod";
export const adminSubscriptionKey = "adminSubscription";
export const adminPermissionsKey = "adminPermissions";
export const adminCreditsKey = "adminCredits";
export const adminBoundsById = "adminBoundsById";

// ─── Sales ───────────────────────────────────────────────────────────────────
export const salesSearchOrganisationQuery = "salesSearchOrganisationQuery";
export const salesOpportunities = "salesOpportunities";
export const salesOpportunity = "salesOpportunity";
export const salesDatasetGeometry = "salesDatasetGeometry";
export const salesProducts = "salesProducts";
export const salesProductCatalogue = "salesProductCatalogue";

// ─── User & Auth ──────────────────────────────────────────────────────────────
export const authenticatedUser = "authenticatedUser";
export const preferredMfa = "preferredMfa";
export const cognitoRole = "cognitoRole";
export const userStatus = "userStatus";
export const userMembership = "userMembership";
export const invoices = "invoices";
export const userInvitations = "userInvitations";
export const userLicences = "userLicences";
export const intercomIdentityHash = "intercomIdentityHash";
export const jwt = "jwt";

// ─── Organisation ─────────────────────────────────────────────────────────────
export const organisation = "organisation";
export const organisationMemberAccount = "organisationMemberAccount";
export const organisationMemberDetails = "organisationMemberDetails";
export const organisationInvitations = "organisationInvitations";

// ─── Billing & Subscription ───────────────────────────────────────────────────
export const availableSubscriptions = "availableSubscriptions";
export const subscription = "subscription";
export const billingUsage = "billingUsage";
export const dailyUsage = "dailyUsage";
export const usageGraph = "usageGraph";
export const plans = "plans";
export const paymentMethod = "paymentMethod";
export const overage = "overage";
export const credits = "credits";

// ─── API & Access ─────────────────────────────────────────────────────────────
export const apiKeys = "apiKeys";
export const apiProducts = "apiProducts";
export const networkAccessibility = "networkAccessibility";
export const permissions = "permissions";

// ─── Datasets & Catalogue ─────────────────────────────────────────────────────
export const datasetsSearchQuery = "datasetsSearchQuery";
export const customDatasetsSearchQuery = "customDatasetsSearchQuery";
export const customDatasetDefinitions = "datasetsCustomDefinitions";
export const releasesDatasetsQuery = "releasesDatasetsQuery";
export const DatumValuesSearchQuery = "DatumValuesSearchQuery";
export const s3BucketContents = "s3BucketContents";
export const datasetsAccessibility = "datasetsAccessibility";
export const definitionsKey = "datasetDefinitions";
export const catalogueDetailKey = "catalogueDetail";

// ─── Batches ──────────────────────────────────────────────────────────────────
export const batchesKey = "batches";
export const batchesDefinitionsKey = "batchesDefinitions";
export const batchesAdditionalPropertiesKey = "batchesAdditionalProperties";
export const batchesQuoteJob = "batchesQuoteJob";
export const batchesQuotedBatchConfig = "batchesQuotedBatchConfig";
export const batchesStartJob = "batchesStartJob";
export const batchesStopJob = "batchesStopJob";
export const batchesSampleResponse = "batchesSampleResponse";

// ─── Clips ────────────────────────────────────────────────────────────────────
export const clipsKey = "clips";
export const clipSummaryKey = "clipSummary";
export const clipInvoiceKey = "clipInvoice";
export const clipConfigKey = "clipConfig";
export const clipGeometryKey = "clipGeometry";
export const clipProductsKey = "clipProducts";

// ─── Maps & Geo ───────────────────────────────────────────────────────────────
export const addressById = "addressById";
export const mapsIndexJson = "mapsIndexJson";
export const mapsLayerJson = "mapsLayerJson"; // Use this with layer name
export const predictiveAddress = "predictiveAddress";
export const predictiveLocality = "predictiveLocality";
export const landParcelsPropertiesKey = "landParcelsProperties";
export const landParcelsCadastresKey = "landParcelsCadastres";
export const buildingsKey = "buildings";
export const buildingsSample = "buildingsSample";

// ─── General ──────────────────────────────────────────────────────────────────
export const latestVersion = "latestVersion";
export const deploymentStatus = "deploymentStatus";
export const demosKey = "demos";
